<template>
  <div class="statusSelector" @click="setUnsetStatus" :class="{active: searchStatusIdsArray.includes(statusId)}">
     {{ statusName }} <i class="fa fa-plus" aria-hidden="true"></i>
  </div>
</template>

<script>
  export default {
     props: {
       statusName: String,
       statusId: Number
     },
     methods: {
       setUnsetStatus(){
          this.$store.dispatch('draft/setUnsetStatusIdInSearch', { statusId: this.statusId, shouldSet: true})
       }
     },
     computed: {
       searchStatusIdsArray(){
         return this.$store.state.draft.searchData.statusesId
       }
     }
  }
</script>

<style lang="scss" scoped>
  .statusSelector{
    display: inline-block;
    padding: 5px 45px 5px 10px;
    border: 1px solid rgb(197, 197, 197);
    margin: 0 3px;
    color:rgb(122, 122, 122);
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    margin-bottom: 10px;
    i{
      position: absolute;
      right: 10px;
      top: 8px;
      font-weight: normal;
      transition: all 300ms ease;
      font-size: 20px;
    }
  }
  .active{
    background-color: rgb(56, 75, 122);
    border-color: rgb(38, 53, 92);
    color: rgb(255, 236, 228);
    i{
      transform: rotate(45deg);
    }
  }
</style>